import { styled } from "@mui/system"
import type { FC } from "react"

import type { Challenge } from "../../../../api/hooks/vote"
import { Hero } from "../../../@shared/hero"
import { Overlay } from "./overlay"

interface Props {
	challenge: Maybe<Challenge>
}

export const VoteHero: FC<Props> = ({ challenge }) => {
	const images = challenge
		? {
				xs: challenge.images.hero560x760,
				sm: challenge.images.hero800x640,
				md: challenge.images.hero1080x560,
				lg: challenge.images.hero1480x560,
				xl: challenge.images.hero1770x670,
			}
		: undefined

	return (
		<StyledHero
			images={images}
			overlay={<Overlay challenge={challenge} />}
			overlaySx={{ minHeight: 200 }}
			minImageHeights={{ xs: 450, sm: 400, md: 300, lg: 300, xl: 400 }}
		/>
	)
}

const StyledHero = styled(Hero)(({ theme }) =>
	theme.unstable_sx({
		mb: 7,
		mt: 3,
	}),
)
